export default {
  versions: '项目',
  errorMessage: '修改失败',
  versionmanage: '版本管理',
  versionName: '版本名称',
  creator: '创建者',
  hideVersion: '隐藏版本',
  title: '版本列表',
  infoTitle: '版本信息',
  versionEdit: '版本编辑',
  deleteSuccessText: '删除成功',
  searchHeadText: '搜索项目',
  createButton: '新建项目',
  createDCOButton: '新建DCO版本',
  createMultiButton: '新建多组合项目',
  deleteButton: '批量删除',
  downloadButton: '批量下载',
  channelName: '渠道：',
  platforms: '平台：',
  packageName: '包名',
  productName: '产品名称：',
  deleteConfirmButton: '删除',
  deleteConfirmText: '确定删除当前项目吗？',
  deleteTitle: '确定删除',
  deleteTips: '删除后当前项目将无法恢复。',
  viewAllProduct: '查看全部产品',
  language: '语言：',
  actionButton: {
    edit: '编辑',
    copy: '复制',
    download: '下载',
    preview: '预览',
    hide: '隐藏',
    renew: '恢复',
    viewData: '查看数据',
    dcoConfiguration: 'DCO 配置',
    push: '推送',
    pushLog: '推送记录',
    pushdownloadLog: '导出 & 下载历史',
    copyToMulti: '复制至多组合',
    copyToPs: '复制至自由编辑',
    copyToDco: '复制至 DCO',
    copyAllResource: '下载全部资源',
  },
  table: {
    column: {
      action: '操作',
      id: '序号',
      versionCount: '最终作品数量',
      description: '版本名称',
      lang: '语言',
      createdTime: '创建时间',
      hide: '隐藏版本',
      unPublished: '未发布',
    },
  },
  createBy: {
    mw: 'MW',
    mindworks: 'Mindworks',
    self: '我',
    placeholder: '选择创建者',
  },
  channelSetting: {
    contentRating: '适龄选择',
    noContentRating: '无',
    contentRating8: '适龄8+',
    contentRating12: '适龄12+',
    contentRating16: '适龄16+',
  },
  materialInteractive: {
    singStep: '一步',
    moreStep: '两步及以上',
    realStep: {
      tips: '试玩步数的设置会影响素材投放效果，请您准确选择。',
    },
    modify: {
      tips: '修改游戏步骤后再次下载/推送会重新计费',
    },
    gameStep: '试玩步数',
    gameJourney: '完整试玩流程的步骤数',
    gameJourneyTips: '从试玩展示到跳转应用商店的交互次数',
    download: '下载',
  },
}
